export default "__VITE_ASSET__8d21e668__"